<div class="project-from-lesson">
  <h4>New PPT project from SME lesson</h4>
  <p class="text-muted small">
    Choose an SME lesson, then set template, layouts, and project parameters.
    The same lesson can be linked to more than one project.
    Run <code>Backend/sql/project_lesson.sql</code> (and
    <code>alter_project_lesson_allow_multi.sql</code> if upgrading an existing DB).
  </p>

  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="row g-3 mb-3">
      <div class="col-md-4">
        <label class="form-label">Project short code</label>
        <input class="form-control" formControlName="ProjectShortCode" placeholder="e.g. ENESample" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Project name</label>
        <input class="form-control" formControlName="ProjectName" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Customer</label>
        <select
          *ngIf="customers.length"
          class="form-select"
          formControlName="CustomerShortCode"
          [disabled]="loadingCustomers"
        >
          <option value="">—</option>
          <option *ngFor="let c of customers" [value]="customerCode(c)">
            {{ customerLabel(c) }}
          </option>
        </select>
        <input
          *ngIf="!loadingCustomers && !customers.length"
          class="form-control"
          formControlName="CustomerShortCode"
          placeholder="Customer short code"
        />
        <span *ngIf="customersLoadError" class="small text-danger d-block">{{ customersLoadError }}</span>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Lesson</label>
      <select class="form-select" formControlName="lessonKey" [disabled]="loadingLessons">
        <option value="">—</option>
        <option *ngFor="let L of availableLessons" [value]="lessonOptionValue(L)">
          {{ lessonOptionLabel(L) }}
        </option>
      </select>
      <span *ngIf="loadingLessons" class="small text-muted">Loading lessons…</span>
      <span *ngIf="!loadingLessons && !availableLessons.length" class="small text-warning d-block">
        No lessons found.
      </span>
    </div>

    <div class="mb-3">
      <label class="form-label">Template</label>
      <select class="form-select" formControlName="templateId" [disabled]="loadingTemplates">
        <option value="">—</option>
        <option *ngFor="let t of templates" [value]="templateCode(t)">{{ templateLabel(t) }}</option>
      </select>
      <span *ngIf="loadingTemplates" class="small text-muted">Loading templates…</span>
      <span *ngIf="templatesLoadError" class="small text-danger d-block">{{ templatesLoadError }}</span>
    </div>

    <div class="mb-3">
      <label class="form-label">Custom layouts (allowed for this project)</label>
      <div *ngIf="!layouts.length" class="small text-muted">No layouts loaded (optional).</div>
      <div class="form-check" *ngFor="let l of layouts">
        <input
          class="form-check-input"
          type="checkbox"
          [id]="'lay-' + layoutCode(l)"
          [value]="layoutCode(l)"
          (change)="onLayoutChange($event)"
          [checked]="isLayoutChecked(layoutCode(l))"
        />
        <label class="form-check-label" [for]="'lay-' + layoutCode(l)">{{ layoutLabel(l) }}</label>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Default slide layout</label>
      <select class="form-select" formControlName="projectDefaultLayoutSC">
        <option value="">(first selected layout)</option>
        <option *ngFor="let code of layoutIds" [value]="code">{{ code }}</option>
      </select>
      <div class="form-text small">
        Used when TOC is pulled into this project. Falls back to the first ticked layout if blank.
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Project-specific fields</label>
      <div formArrayName="customFields">
        <div *ngFor="let field of customFields.controls; let i = index" [formGroupName]="i" class="row mb-2">
          <div class="col">
            <input placeholder="Name" formControlName="name" class="form-control" />
          </div>
          <div class="col">
            <input placeholder="Value" formControlName="value" class="form-control" />
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-outline-danger" (click)="removeCustomField(i)">×</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="addCustomField()">Add field</button>
    </div>

    <button type="submit" class="btn btn-primary" [disabled]="!canSubmit()">
      {{ saving ? 'Saving…' : 'Create project' }}
    </button>
    <p class="small text-muted mt-2 mb-0" *ngIf="submitBlockers.length && !saving">
      Still needed: {{ submitBlockers.join(' · ') }}
    </p>
  </form>
</div>
